/**
 * M365 Email OAuth Callback Page
 * Handles the OAuth redirect from Microsoft and sends the code to the parent window
 */

import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const M365EmailCallback = () => {
  const location = useLocation();

  useEffect(() => {
    // Parse the authorization code from URL
    const params = new URLSearchParams(location.search);
    const code = params.get('code');
    const error = params.get('error');
    const errorDescription = params.get('error_description');

    if (error) {
      // Send error to parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'm365-email-auth-error',
          error: error,
          errorDescription: errorDescription,
        }, window.location.origin);
      }
      window.close();
      return;
    }

    if (code) {
      // Send code to parent window
      if (window.opener) {
        window.opener.postMessage({
          type: 'm365-email-auth-success',
          code: code,
        }, window.location.origin);
      }
      // Window will be closed by parent after processing
    } else {
      // No code and no error - something went wrong
      if (window.opener) {
        window.opener.postMessage({
          type: 'm365-email-auth-error',
          error: 'no_code',
          errorDescription: 'No authorization code received',
        }, window.location.origin);
      }
      window.close();
    }
  }, [location]);

  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      height: '100vh',
      fontFamily: 'Arial, sans-serif',
      backgroundColor: '#f8f9fa',
    }}>
      <div style={{
        padding: '2rem',
        backgroundColor: 'white',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
        textAlign: 'center',
      }}>
        <div style={{
          width: '40px',
          height: '40px',
          border: '4px solid #2c5f2d',
          borderTopColor: 'transparent',
          borderRadius: '50%',
          animation: 'spin 1s linear infinite',
          margin: '0 auto 1rem',
        }}></div>
        <h2 style={{ margin: '0 0 0.5rem 0', color: '#333' }}>
          Procesando autenticación M365...
        </h2>
        <p style={{ margin: 0, color: '#666' }}>
          Esta ventana se cerrará automáticamente
        </p>
      </div>
      <style>{`
        @keyframes spin {
          to { transform: rotate(360deg); }
        }
      `}</style>
    </div>
  );
};

export default M365EmailCallback;
